import React from 'react'

export const SuggProdContext = React.createContext<any>(null)
